// @flow
import { Map } from "immutable"

import type { Action } from "./actions"
import type { State } from "booking/services/types"

// FIXME: refactor to use plain object
export type InfantsConditions = ?Map

const infantsConditionsReducer = (
  state: InfantsConditions = null,
  action: Action,
): InfantsConditions => {
  switch (action.type) {
    case "SET_INFANT_CONDITIONS":
      return action.payload
    default:
      return state
  }
}

export default infantsConditionsReducer

// Data selectors
// ===
export const getInfantsConditions = (state: State) => state.reservation.infantsConditions
